import React, { useEffect } from "react";
import './style.css';
import './bootstrap.min.css';


function Testimonial() {
useEffect(() => {
    document.title = "Customer Reviews | What Our Guests Say - Srinivasa Mandapam";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
        metaDesc.setAttribute('content', "Read honest reviews and testimonials from our happy clients about their wedding and event experience at Srinivasa Kalyana Mandapam, Chennai.");
    }
}, []);
  useEffect(() => {
    if (window.$) {
      window.$(".testimonial-carousel").owlCarousel({
        autoplay: true,
        smartSpeed: 1000,
        center: true,
        margin: 24,
        dots: true,
        loop: true,
        nav: true,
        items: 1,
        navText: [
          '<i class="fa fa-arrow-left"></i>',
          '<i class="fa fa-arrow-right"></i>'
        ],
        responsive: {
          0: { items: 1 },
          992: { items: 3 }
        }
      });
    }
  }, []);

  return (
    <>
      {/* Header */}
      <div>
      <div className="gallery-header-section wow fadeIn" data-wow-delay="0.1s">
    <div className="container text-center">
       

      <h1 className="display-4 fs-2 fs-md-1 fs-lg-0 animated slideInDown fw-bold text-white">
          Client Testimonials
      </h1>
        <p className="animated slideInDown fs-5 text-white">
            Hear What Our Happy Guests Have to Say About Their Special Day.
            
        </p>
    </div>
</div>
</div>

      {/* Testimonials */}
      <div className="container-xxl py-5">
        <div className="container">
          <h1 className="display-5 text-center mb-5">
            What Our Clients Say
          </h1>

          <div className="owl-carousel testimonial-carousel">

            {/* Review 1 */}
            <div className="testimonial-item text-center">
              {/* <img
                className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                src="img/user.png"
                alt="Client"
                style={{ width: "90px", height: "90px" }}
              /> */}
               <img
                  src={"https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                  className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                     alt="Client"
                    style={{ width: "90px", height: "90px" }}

                />
              <div className="testimonial-text rounded p-4">
                <p>
                  We recently attended a wedding at Srinivasa Kalyana Mandapam.
                  The hall was spacious, clean and very well maintained.
                  Air-conditioning was excellent and the staff were extremely supportive.
                </p>
                <h5 className="mb-1">Nithish S</h5>
                <span className="fst-italic">Google Review</span>
              </div>
            </div>

            {/* Review 2 */}
            <div className="testimonial-item text-center">
              {/* <img
                className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                src="img/user.png"
                alt="Client"
                style={{ width: "90px", height: "90px" }}
              /> */}
               <img
                  src={"https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                  className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                     alt="Client"
                    style={{ width: "90px", height: "90px" }}

                />
              <div className="testimonial-text rounded p-4">
                <p>
                  Nice ambience and budget friendly wedding hall.
                  Easily accessible location with good facilities.
                  Perfect choice for traditional functions.
                </p>
                <h5 className="mb-1">Manju</h5>
                <span className="fst-italic">Google Review</span>
              </div>
            </div>

            {/* Review 3 */}
            <div className="testimonial-item text-center">
              {/* <img
                className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                src="img/user.png"
                alt="Client"
                style={{ width: "90px", height: "90px" }}
              /> */}
              <img
                  src={"https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                  className="img-fluid rounded-circle border border-2 p-2 mx-auto mb-4"
                     alt="Client"
                    style={{ width: "90px", height: "90px" }}

                />

              <div className="testimonial-text rounded p-4">
                <p>
                  Srinivasa Kalyana Mandapam is a good place for weddings
                  and receptions. Clean surroundings and helpful management.
                  Value for money.
                </p>
                <h5 className="mb-1">Jeevitha S R</h5>
                <span className="fst-italic">Google Review</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Testimonial;
